import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import { toast } from 'react-toastify';
import BudgetForm from '../../components/Budgets/BudgetForm';
import budgetService from '../../services/budgetService';

const BudgetEdit = () => {
  const { id } = useParams();
  const [budget, setBudget] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadBudget();
  }, [id]);

  const loadBudget = async () => {
    try {
      const data = await budgetService.getBudget(id);
      setBudget(data.data);
    } catch (error) {
      console.error('Error loading budget:', error);
      toast.error('Failed to load budget');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-gray-500">Loading budget...</div>
      </div>
    );
  }

  if (!budget) {
    return (
      <div className="container mx-auto px-4 py-8">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-900">Budget not found</h2>
          <Link to="/budgets" className="text-blue-600 hover:text-blue-800 mt-4 inline-block">
            Back to Budgets
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-6">
        <Link
          to="/budgets"
          className="flex items-center text-gray-600 hover:text-gray-900 mb-4"
        >
          <FiArrowLeft className="mr-2" />
          Back to Budgets
        </Link>
        <h1 className="text-3xl font-bold text-gray-900">Edit Budget</h1>
        <p className="text-gray-600 mt-1">
          Update budget for {budget.project?.name || 'project'}
        </p>
      </div>

      <BudgetForm budget={budget} />
    </div>
  );
};

export default BudgetEdit;

